<template>
    <entity-reader entity="systemPage" :id="id" :use-sharing="false">
        <template v-slot:[`reader`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <div class="text-h5">{{ doc.name }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div v-html="doc.details"></div>
                </v-col>
            </v-row>
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
export default {
    name: 'PlotReader',
    components: {
        'entity-reader': EntityReader,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
}
</script>
